import { gql } from '@apollo/client';
import { BULK_REBALANCE_PORTFOLIO_REPORT_FIELDS } from './portfolioReportLookupFields';

/**
 * Live reports tagged with `optimizerRunId` (`fetchPortfolioReports`).
 *
 * Bulk rebalance uses this while a LIVE run is in progress (and to look up
 * missing/failed reports). Keep the selection identical to
 * `FETCH_OPTIMIZED_PORTFOLIO_REPORTS` via `BULK_REBALANCE_PORTFOLIO_REPORT_FIELDS`.
 *
 * Not the portfolio widget dry-run path (`OptimizerRunV2Mode.DryRun` /
 * v1 `dryRun: true` → `fetchOptimalPortfolio`).
 */
export const FETCH_PORTFOLIO_REPORTS_BY_OPTIMIZER_RUN = gql`
  query fetchPortfolioReportsByOptimizerRun(
    $input: FetchPortfolioReportsInput!
  ) {
    fetchPortfolioReports(input: $input) {
      portfolioReports {
        ${BULK_REBALANCE_PORTFOLIO_REPORT_FIELDS}
      }
      totalCount
    }
  }
`;
